import { render, staticRenderFns } from "./Academy.vue?vue&type=template&id=a7ec1198&scoped=true"
import script from "./Academy.vue?vue&type=script&lang=js"
export * from "./Academy.vue?vue&type=script&lang=js"
import style0 from "./Academy.vue?vue&type=style&index=0&id=a7ec1198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ec1198",
  null
  
)

export default component.exports